import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ExtensionsListComponent } from './extensions/extensions-list/extensions-list.component';
import { VOIPStatusComponent } from './status/status.component';
import { VOIPCDRComponent } from './cdr/cdr.component';
import { VoipScheduleConfigComponent } from './schedule-config/voip-schedule-config.component';
import { QueuesListComponent } from './queues/queues-list/queues-list.component';
import { DialPlansListComponent } from './dial-plans/dial-plans-list/dial-plans-list.component';
import { DDIsListComponent } from './ddis/ddis-list/ddis-list.component';

const routes: Routes = [
    {
        path: 'voip/status',
        children: [
            { path: '', component: VOIPStatusComponent }
        ]
    },
    {
        path: 'voip/extensions',
        children: [
            { path: '', component: ExtensionsListComponent }
        ]
    },
    {
        path: 'voip/cdr',
        children: [
            { path: '', component: VOIPCDRComponent }
        ]
    },
    {
        path: 'voip/schedule-config',
        children: [
            { path: '', component: VoipScheduleConfigComponent }
        ]
    },
    {
        path: 'voip/queues',
        children: [
            { path: '', component: QueuesListComponent }
        ]
    },
    {
        path: 'voip/dial-plans',
        children: [
            { path: '', component: DialPlansListComponent }
        ]
    },
    {
        path: 'voip/ddis',
        children: [
            { path: '', component: DDIsListComponent }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class VOIPRoutingModule { }
